document.addEventListener("DOMContentLoaded", function() {
    var featuresElement = document.getElementById("special-features");
    if (featuresElement) {
        var featuresText = featuresElement.innerText || featuresElement.textContent;

        var featuresArray = featuresText.split(". ").filter(Boolean);

        if (featuresArray.length > 1) {
            var listHTML = "<ul>";
            featuresArray.forEach(function(feature) {
                listHTML += "<li>" + feature.trim() + ".</li>"; 
            });
            listHTML += "</ul>";

            featuresElement.innerHTML = listHTML;
        }
    }
});

// Tabs //
document.addEventListener('DOMContentLoaded', () => {
  const tabTitles = document.querySelectorAll('.tab-title span');
  tabTitles.forEach(tab => {
    tab.addEventListener('click', () => {
      const parentTitle = tab.parentElement;

      if (parentTitle.classList.contains('active')) {
        parentTitle.classList.remove('active');
      } else {
        document.querySelectorAll('.tab-title').forEach(title => {
          title.classList.remove('active');
        });
        parentTitle.classList.add('active');
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const rows = document.querySelectorAll("#specifications .specifications-table tr");
  rows.forEach(row => {
      const th = row.querySelector("th");
      const td = row.querySelector("td");
      if ((!th || th.textContent.trim() === "") && (!td || td.textContent.trim() === "")) {
          row.remove(); 
      }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let tabTitles = document.querySelectorAll(".tabs-nav .tab-title");
  let tabContents = document.querySelectorAll(".tab-content");

  function isContentEmpty(element) {
    let clone = element.cloneNode(true);
    clone.querySelectorAll('br, hr, img, iframe, video, span:empty, div:empty, p:empty').forEach(el => el.remove());
    return clone.textContent.trim() === "";
  }

  tabContents.forEach((tabContent, index) => {
      if (isContentEmpty(tabContent)) {
          tabTitles[index].style.display = "none";
          tabContent.style.display = "none";
      }
  });

  let visibleTabs = document.querySelectorAll(".tabs-nav .tab-title:not([style*='display: none'])");
  if (visibleTabs.length > 0) {
      visibleTabs.forEach(tab => tab.classList.remove("active")); 
      tabContents.forEach(content => content.style.display = "none"); 
      visibleTabs[0].classList.add("active");
      let firstVisibleContent = visibleTabs[0].nextElementSibling;
      if (firstVisibleContent && firstVisibleContent.classList.contains("tab-content")) {
          firstVisibleContent.style.display = "block";
      }
  }

  tabTitles.forEach((tab, index) => {
      tab.addEventListener("click", function () {
          if (tab.style.display === "none") return; 

          tabTitles.forEach(t => t.classList.remove("active")); 
          tabContents.forEach(c => c.style.display = "none");
          tab.classList.add("active");
          let correspondingContent = tab.nextElementSibling;
          if (correspondingContent && correspondingContent.classList.contains("tab-content")) {
              correspondingContent.style.display = "block";
          }
      });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const specWrapper = document.querySelector(".product-specification");

  if (specWrapper) {
      const childDivs = specWrapper.querySelectorAll("div");
      let hasContent = false;

      childDivs.forEach(div => {
          if (div.textContent.trim() !== "") {
              hasContent = true;
          }
      });

      if (!hasContent) {
          specWrapper.style.display = "none";
      }
    }
});